export enum RuleStatus {
	Active = 'active',
	Inactive = 'inactive'
}
